import React, { useContext } from 'react';
import { CustomInitContext } from '../CustomInit';
import { useAtom } from 'jotai';
import { customTravelFormStateAtom } from '@/atoms/customTravelFormState';
import SelectLocationForm from '@/components/CustomTravel/ServiceForm/forms/SelectLocationForm';

interface SelectLocationProps {}

const SelectLocation: React.FC<SelectLocationProps> = () => {
  const [{ destinations }] = useAtom(customTravelFormStateAtom);

  const { overseasProduct } = useContext(CustomInitContext);
  const visitAreas = overseasProduct?.productFamily?.visitAreas || [];
  const initialValues = destinations?.reduce((acc, cur) => {
    if (cur?.codes) {
      return {
        ...acc,
        [cur?.codes?.join('-')]: true,
      };
    }
    return acc;
  }, {});

  return (
    <SelectLocationForm
      visitAreas={visitAreas}
      externalValues={initialValues && { destinations: initialValues }}
      recommendSelectedCount={destinations?.length || 0}
    />
  );
};

export default SelectLocation;
